__turbopack_context__.v({
  "haadVideo": "index-module-scss-module__Qe2P6G__haadVideo",
});
